import React from 'react'

interface DataResidencyModalProps {
  isOpen: boolean
  onClose: () => void
}

const DataResidencyModal: React.FC<DataResidencyModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-3xl font-bold text-gray-900">Data Residency Statement</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Divider */}
          <div className="border-b border-blue-200 mb-6"></div>

          {/* Content */}
          <div className="prose prose-gray max-w-none">
            <p className="text-gray-700 mb-6">
              EceptionistCX is hosted on secure Microsoft Azure cloud infrastructure. We recognize that where your data is stored and processed is critical to compliance, trust, and performance.
            </p>

            <section className="mb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Primary Hosting Regions</h3>
              <p className="text-gray-700 mb-4">
                Customer data is stored in secure Azure data centers located in the United States, Canada, and the European Union, depending on customer requirements.
              </p>
            </section>

            <section className="mb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Regional Options</h3>
              <p className="text-gray-700 mb-4">
                Customers may select hosting in specific regions where required by regulation or organizational policy (e.g., Canada-only, EU-only).
              </p>
            </section>

            <section className="mb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Cross-Border Transfers</h3>
              <p className="text-gray-700 mb-4">
                For customers in the EU, UK, and Switzerland, cross-border data transfers are protected through our participation in the EU-U.S. Data Privacy Framework (DPF), the UK Extension to the DPF, and the Swiss-U.S. DPF. For Canadian customers, data residency is available within Canada to support PIPEDA and provincial requirements.
              </p>
            </section>

            <section className="mb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Safeguards</h3>
              <p className="text-gray-700 mb-4">
                Regardless of region, all customer data is protected by strong technical and organizational measures, including encryption, access controls, and continuous monitoring.
              </p>
            </section>

            <section className="mb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Binding Commitments</h3>
              <p className="text-gray-700 mb-4">
                Detailed data residency commitments, including specific hosting regions and subprocessors, are governed by each customer's Master Services Agreement (MSA) and Data Processing Agreement (DPA).
              </p>
            </section>
          </div>

          {/* Footer */}
          <div className="border-t border-gray-200 pt-6 mt-8">
            <button
              onClick={onClose}
              className="w-full px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-blue-600 rounded-md hover:bg-blue-700 transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DataResidencyModal




